import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messagesCa from './ca.js'
import messagesEs from './es.js'
import messagesPo from './po.js'
import questCa from './questionnaire/CA_QUESTIONNAIRE.js'
import questPo from './questionnaire/PO_QUESTIONNAIRE.js'
import CaHelpItems from './questionnaire/CA_QUESTIONNAIRE_HELP_ITEMS.js'
import PoHelpItems from './questionnaire/PO_QUESTIONNAIRE_HELP_ITEMS.js'
import questEs from './questionnaire/ES_QUESTIONNAIRE.js'
import EsHelpItems from './questionnaire/ES_QUESTIONNAIRE_HELP_ITEMS.js'

Vue.use(VueI18n)

const messages = {
  ES: messagesEs,
  ESEC: messagesEs,
  CA: messagesCa,
  PO: messagesPo,
  CA_QUESTIONNAIRE: questCa,
  ES_QUESTIONNAIRE: questEs,
  ESEC_QUESTIONNAIRE: questEs,
  PO_QUESTIONNAIRE: questPo,
  CA_QUESTIONNAIRE_HELP_ITEMS: CaHelpItems,
  ES_QUESTIONNAIRE_HELP_ITEMS: EsHelpItems,
  ESEC_QUESTIONNAIRE_HELP_ITEMS: EsHelpItems,
  PO_QUESTIONNAIRE_HELP_ITEMS: PoHelpItems
}
const langKey = 'lang'

const i18n = new VueI18n({
  locale: (localStorage.getItem(langKey) || 'CA'),
  fallbackLocale: 'CA',
  messages,
  silentTranslationWarn: true
})

Vue.prototype.$locale = {
  change (lang) {
    localStorage.setItem(langKey, lang)
    i18n.locale = localStorage.getItem(langKey)
  },
  current () {
    return i18n.locale
  }
}

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js